import React from "react";

const EmailRecipientExpandedRow = ({ data }) => {
  return (
    <div className="w-full">
      <div className="p-2 space-y-4 shadow-md border-l-2 border-primary mb-2">
        <div className="text-xs font-medium  border border-gray-200">
          <div className="grid  grid-cols-3 gap-5 m-3">
            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-left ml-2">
                Created By:{" "}
              </div>
              <div className="font-bold ">
                {data.createdBy ? data.createdBy : ""}
              </div>
            </div>

            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-left ml-2">
                Created Date:{" "}
              </div>
              <div className="font-bold ">
                {data.createdOn
                  ? new Date(data.createdOn).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-right mr-2 "></div>
              <div className="font-bold "></div>
            </div>
            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-left ml-2">
                Modified By:{" "}
              </div>
              <div className="font-bold ">
                {" "}
                {data.updatedBy ? data.updatedBy : ""}
              </div>
            </div>
            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-left ml-2">
                Modified Date:{" "}
              </div>
              <div className="font-bold ">
                {data.updatedOn
                  ? new Date(data.updatedOn).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid grid-cols-3">
              <div className="text-xs text-gray-700 text-right mr-2"></div>
              <div className="font-bold "></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailRecipientExpandedRow;
